"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExternalLink = void 0;
/** @jsx jsx */
var core_1 = require("@theme-ui/core");
var gatsby_1 = require("gatsby");
var react_1 = require("react");
var OutboundLink_1 = __importDefault(require("../OutboundLink"));
var externalLinkExtensions = ["pdf"];
var isExternalLink = function (link) {
    try {
        return !!new URL(link);
    }
    catch (e) {
        var extension = link.split(".").pop();
        return ((extension ? externalLinkExtensions.includes(extension) : false) || false);
    }
};
exports.isExternalLink = isExternalLink;
var Link = function (_a) {
    var children = _a.children, className = _a.className, onClick = _a.onClick, partiallyActive = _a.partiallyActive, _b = _a.activeClassName, activeClassName = _b === void 0 ? "active" : _b, title = _a.title, to = _a.to;
    if (!to) {
        return ((0, core_1.jsx)("span", { className: className, onClick: onClick, title: title, sx: function (theme) {
                var _a;
                return (__assign({}, (_a = theme.styles) === null || _a === void 0 ? void 0 : _a.a));
            } }, children));
    }
    if ((0, exports.isExternalLink)(to)) {
        return ((0, core_1.jsx)(OutboundLink_1.default, { className: className, href: to, onClick: onClick, title: title }, children));
    }
    return ((0, core_1.jsx)(gatsby_1.Link, { activeClassName: activeClassName, className: className, onClick: onClick, partiallyActive: partiallyActive, title: title, to: to, sx: function (theme) {
            var _a;
            return (__assign({}, (_a = theme.styles) === null || _a === void 0 ? void 0 : _a.a));
        } }, children));
};
exports.default = (0, react_1.memo)(Link);
